const OTP_PURPOSES = {
  default: "default",
  login: "login",
  loginWithRepayToken: "loginWithRepayToken",
  loanRequest: "loanRequest",
  loanRequestChangePhoneNumber: "loanRequestChangePhoneNumber"
};

export default OTP_PURPOSES;
